import { queryOptions } from "@tanstack/react-query";

import { compilationService } from "./service";

export const compilationListQuery = () =>
  queryOptions({
    queryKey: ["compilations", "list"],
    queryFn: ({ signal }) =>
      compilationService.getAllCompilationPreviews({ signal }),
  });

export const compilationQuery = (id: string) =>
  queryOptions({
    queryKey: ["compilation", id],
    queryFn: ({ signal }) =>
      compilationService.getCompilationById(id, { signal }),
  });
